interface KpiTile {
	label: string;
	value: string;
	hint?: string;
}

interface HalfLifeKpiRowProps {
	tiles: [KpiTile, KpiTile, KpiTile, KpiTile];
}

export function HalfLifeKpiRow({ tiles }: HalfLifeKpiRowProps) {
	return (
		<div className="grid grid-cols-2 gap-3 md:grid-cols-4">
			{tiles.map((t) => (
				<div key={t.label} className="rounded-xl border border-border bg-card p-4 transition-colors">
					<p className="text-[11px] font-medium uppercase tracking-[0.2em] text-muted-foreground">
						{t.label}
					</p>
					<p className="mt-2 font-mono text-2xl font-semibold tabular-nums text-foreground">{t.value}</p>
					{t.hint && <p className="mt-1 text-xs text-muted-foreground">{t.hint}</p>}
				</div>
			))}
		</div>
	);
}
